import React from 'react';
import logo from '../assets/logo.png';
import africa from '../assets/africa.png';
import './LoadingScreen.css';

const LoadingScreen = () => {
  return (
    <div className="loading-screen-advanced">
      
      {/* Background Map */}
      <img src={africa} alt="Map" className="loading-map" />
      
      {/* Outer Orbit */}
      <div className="orbit orbit-outer">
        <div className="orbit-trail"></div>
        <div className="orbit-dot"></div>
      </div>

      {/* Inner Orbit */}
      <div className="orbit orbit-inner">
        <div className="orbit-trail"></div>
        <div className="orbit-dot"></div>
      </div>

      {/* Center Content */}
      <div className="loading-content">
        <img src={logo} alt="Le-Ma Systems" className="loading-center-logo" />

        <div className="loading-progress-container">
          <div className="loading-bar-track">
            <div className="loading-bar-fill">
              <div className="loading-bar-head"></div>
            </div>
          </div>
          <div className="loading-text">L O A D I N G . . .</div>
        </div>
      </div>

    </div>
  );
};

export default LoadingScreen;
